import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
  'import-file-error.invalid-file-type': {
    id: 'import-file-error.invalid-file-type',
    defaultMessage: 'We only support CSV files for import',
    description:
      'The error message shown when a user tries to import a file other than a CSV.'
  },
  'import-file-error.too-many-files': {
    id: 'import-file-error.too-many-files',
    defaultMessage: 'We can only import one file at a time. Select one file first.',
    description:
      'The error message shown when a user tries to drag and drop multiple files for import'
  },
  'import-file-error.malformed-or-unknown': {
    id: 'import-file-error.malformed-or-unknown',
    defaultMessage:
      'We couldn’t upload the file you selected. Try again or select another file.',
    description:
      'The error message shown when a user tries to import a CSV that is malformed, empty, or an unknown error has occured.'
  },
  'import-progress.importing-file': {
    id: 'import-progress.importing',
    defaultMessage: 'Importing file…',
    description:
      'The message shown when a file is being imported to database to show its progress.'
  },
  'flag-error-message.cannot-read-pasted-content': {
    id: 'flag-error-message.cannot-read-pasted-content',
    defaultMessage: 'Pasted content could not be read',
    description:
      'The error message shown when a user tries to paste content, but the contents cannot be read.'
  },
  'flag-error-message.unexpected-data-type': {
    id: 'flag-error-message.unexpected-data-type',
    defaultMessage: 'We’re having some issues pasting your content. Try again.',
    description:
      'The error message shown when a user tries to paste content, but reached an unexpected error.'
  },
  'flag-warning-message.read-only': {
    id: 'flag-warning-message.read-only',
    defaultMessage: 'You don’t have edit access',
    description:
      'The warning title shown when a user tries to paste content into a read-only database.'
  },
  'flag-warning-description.read-only': {
    id: 'flag-warning-description.read-only',
    defaultMessage: 'You need edit access to this database to paste content.',
    description:
      'The warning message shown when a user tries to paste content into a read-only database.'
  },
  'flag-warning-message.restricted-content-cant-be-copied': {
    id: 'flag-warning-message.restricted-content-cant-be-copied',
    defaultMessage: 'Media or files can’t be copied',
    description:
      'The warning title shown when a user tries to copy media but the content is restricted.'
  },
  'flag-warning-description.restricted-content-cant-be-copied': {
    id: 'flag-warning-description.restricted-content-cant-be-copied',
    defaultMessage:
      'This database is restricted. You can’t copy media or files on restricted content.',
    description:
      'The warning message shown when a user tries to copy media but the content is restricted.'
  },
  'flag-info-message.entries-filtered': {
    id: 'flag-info-message.entries-filtered',
    defaultMessage: 'Some entries are not visible in this view',
    description:
      'The message shown when a user pastes some entries that do not meet the filters criteria'
  },
  'flag-info-description.entries-filtered': {
    id: 'flag-info-description.entries-filtered',
    defaultMessage:
      '{numberOfEntriesPasted, plural, one {# entry was} other {# entries were}} pasted but some were filtered out of the current view.',
    description:
      'The description shown when a user pastes some entries that do not meet the filters criteria'
  },
  'flag-info-message.pasted-into-sort': {
    id: 'flag-info-message.pasted-into-sort',
    defaultMessage: 'Some content may have shifted',
    description:
      'The message shown when a user pastes into a field that has a sort applied. Their values might not be where they expected because they will be sorted.'
  },
  'flag-info-description.pasted-into-sort': {
    id: 'flag-info-description.pasted-into-sort',
    defaultMessage:
      'Entries were pasted successfully but may have moved due to a sorted field.',
    description:
      'The description shown when a user pastes into a field that has a sort applied. Their values might not be where they expected because they will be sorted.'
  },
  'flag-warning-message.dismiss-action': {
    id: 'flag-warning-message.dismiss-action',
    defaultMessage: 'Dismiss',
    description: 'Text for the dismiss action button on the flag.'
  },
  'flag-warning-description.structure-locked': {
    id: 'flag-warning-description.structure-locked',
    defaultMessage:
      'We couldn’t paste some or all of your data. You must unlock the database structure to add or edit content.',
    description:
      'The message for the flag that appears when the user pastes content that would normally add fields/entries to the database, but the structure is locked.'
  },
  'flag-warning-message.structure-locked': {
    id: 'flag-warning-message.structure-locked',
    defaultMessage: 'Database structure is locked',
    description:
      'The title for the flag that appears when the user pastes content that would normally add fields/entries to the database, but the structure is locked.'
  },
  'flag-warning-message.field-settings-updated': {
    id: 'flag-warning-message.field-settings-updated',
    defaultMessage: 'Field settings updated',
    description:
      "This message is shown in a snackbar when the field's settings were automatically updated as a result of the content pasted."
  },
  'flag-warning-message.pasting-content-that-doesnt-match': {
    id: 'flag-warning-message.pasting-content-that-doesnt-match',
    defaultMessage: 'Content doesn’t match field',
    description:
      'This message is shown in a snackbar when the user pastes values into another field where they cannot be converted properly.'
  },
  'flag-warning-description.pasting-content-that-doesnt-match': {
    id: 'flag-warning-description.pasting-content-that-doesnt-match',
    defaultMessage:
      'We couldn’t paste the content because it doesn’t match this field’s formatting.',
    description:
      'The description for the flag that appears when the user pastes content that cannot be converted properly'
  },
  'flag-warning-description.field-settings-updated': {
    id: 'flag-warning-description.field-settings-updated',
    defaultMessage: 'To paste this content, some field settings were updated.',
    description:
      "The description for the flag that appears when the field's settings were automatically updated as a result of the content pasted."
  }
});
